export const appSettingsCustomAttributesData = "/app_settings/custom_attributes_data";
